import React from 'react';
import PropTypes from 'prop-types';
import SecuritiesTable from './SecuritiesTable';
import DeleteSecurityConfirmationModal from './DeleteSecurityConfirmationModal';
const SecurityComponent = ({
  securitiesData,
  handleGridChanges,
  gridColumnState,
  handleGridColumnStateChange,
  refreshGridSecurityData,
  handleDeleteButtonClick,
  handleEditButtonClick,
  handleDismissErrorMessage,
  handleConfirmButtonClick,
  showDeleteSecurityConfirmationModal,
  toggleShowDeleteSecurityConfirmationModal,
  gridCurrentState,
  selectedSecurity,
  handleSubmit,
  handleDeleteSecurity,
  validationMessage,
}) => {
  return (
    <div>
      <div>
        <SecuritiesTable
          securitiesData={securitiesData}
          handleGridChanges={handleGridChanges}
          gridColumnState={gridColumnState}
          handleGridColumnStateChange={handleGridColumnStateChange}
          refreshGridSecurityData={refreshGridSecurityData}
          handleEditButtonClick={handleEditButtonClick}
          handleDismissErrorMessage={handleDismissErrorMessage}
          handleDeleteButtonClick={handleDeleteButtonClick}
        />
      </div>
      <DeleteSecurityConfirmationModal
        showDeleteSecurityConfirmationModal={
          showDeleteSecurityConfirmationModal
        }
        handleConfirm={handleConfirmButtonClick}
        toggleShowDeleteSecurityConfirmationModal={
          toggleShowDeleteSecurityConfirmationModal
        }
        gridCurrentState={gridCurrentState}
        initialValues={selectedSecurity}
        handleSubmit={handleSubmit}
        deleteSecurity={handleDeleteSecurity}
        validationMessage={validationMessage}
        handleDismissErrorMessage={handleDismissErrorMessage}
      />
    </div>
  );
};

SecurityComponent.propTypes = {
  securitiesData: PropTypes.arrayOf(
    PropTypes.shape({
      SecuritiesSnapshotID: PropTypes.number,
      ReportPeriodID: PropTypes.number,
      SecurityName: PropTypes.string,
      Issuer: PropTypes.string,
      Class: PropTypes.string,
      IsSystemGenerated: PropTypes.bool,
      REITStatus: PropTypes.bool,
      REITName: PropTypes.string,
      PropertyName: PropTypes.string,
      InitialQuarter: PropTypes.string,
      FinalQuarter: PropTypes.string,
      ClientAccountNumber: PropTypes.number,
    })
  ),

  refreshGridSecurityData: PropTypes.func.isRequired,
  handleGridColumnStateChange: PropTypes.func.isRequired,
  handleGridChanges: PropTypes.func.isRequired,
  gridColumnState: PropTypes.object.isRequired,
  gridCurrentState: PropTypes.object.isRequired,
  handleDeleteButtonClick: PropTypes.func.isRequired,
  handleEditButtonClick: PropTypes.func.isRequired,
  handleDismissErrorMessage: PropTypes.func.isRequired,
  handleConfirmButtonClick: PropTypes.func.isRequired,
  showDeleteSecurityConfirmationModal: PropTypes.bool.isRequired,
  toggleShowDeleteSecurityConfirmationModal: PropTypes.func.isRequired,
  selectedSecurity: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  handleDeleteSecurity: PropTypes.func.isRequired,
};

export default SecurityComponent;
